import { useEffect } from "react";
import type { BridgeTheme } from "./types";

export function applyTheme(theme: BridgeTheme) {
  const s = document.documentElement.style;

  // Colors
  s.setProperty("--bg-deep", theme.colors.bgDeep);
  s.setProperty("--bg-panel", theme.colors.bgPanel);
  s.setProperty("--bg-surface", theme.colors.bgSurface);
  s.setProperty("--border-color", theme.colors.borderColor);
  s.setProperty("--border-highlight", theme.colors.borderHighlight);
  s.setProperty("--color-text", theme.colors.text);
  s.setProperty("--color-text-dim", theme.colors.textDim);
  s.setProperty("--color-text-bright", theme.colors.textBright);
  s.setProperty("--color-blue", theme.colors.blue);
  s.setProperty("--color-teal", theme.colors.teal);
  s.setProperty("--color-green", theme.colors.green);
  s.setProperty("--color-yellow", theme.colors.yellow);
  s.setProperty("--color-orange", theme.colors.orange);
  s.setProperty("--color-red", theme.colors.red);
  s.setProperty("--color-purple", theme.colors.purple);
  s.setProperty("--color-amber", theme.colors.amber);

  // Fonts
  s.setProperty("--font-mono", theme.fonts.mono);
  s.setProperty("--font-body", theme.fonts.body);

  // Panel
  s.setProperty("--panel-bg", theme.panel.bg);
  s.setProperty("--panel-blur", theme.panel.blur);
  s.setProperty("--panel-border", theme.panel.border);
  s.setProperty("--panel-titlebar-bg", theme.panel.titlebarBg);
  s.setProperty("--panel-titlebar-border", theme.panel.titlebarBorder);
  s.setProperty("--panel-titlebar-hover-bg", theme.panel.titlebarHoverBg);
  s.setProperty("--panel-drag-icon", theme.panel.dragIcon);
  s.setProperty("--panel-drag-icon-hover", theme.panel.dragIconHover);
  s.setProperty("--panel-title-color", theme.panel.titleColor);
  s.setProperty("--panel-radius", theme.panel.radius);

  // Viewscreen
  s.setProperty("--viewscreen-frame-border", theme.viewscreen.frameBorder);
  s.setProperty("--viewscreen-frame-glow", theme.viewscreen.frameGlow);
  s.setProperty("--viewscreen-frame-glow-size", theme.viewscreen.frameGlowSize);
  s.setProperty("--viewscreen-corner-accent", theme.viewscreen.cornerAccent);
  s.setProperty("--viewscreen-radius", theme.viewscreen.radius);
  s.setProperty("--viewscreen-scanline-opacity", String(theme.viewscreen.scanlineOpacity));
  s.setProperty("--viewscreen-vignette-opacity", String(theme.viewscreen.vignetteOpacity));

  // Alerts
  s.setProperty("--alert-normal", theme.alerts.normal);
  s.setProperty("--alert-yellow", theme.alerts.yellow);
  s.setProperty("--alert-red", theme.alerts.red);
}

export function useBridgeTheme(theme: BridgeTheme) {
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);
}
